// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CloudInventoryAccountWithRelationsSchema } from './CloudInventoryAccountRelationsSchema'
import type { CloudInventoryAccountWithRelations } from './CloudInventoryAccountRelationsSchema'
import { CloudIpAllocationSchema } from './CloudIpAllocationSchema';

/////////////////////////////////////////
// CLOUD IP ALLOCATION RELATION SCHEMA
/////////////////////////////////////////

export type CloudIpAllocationRelations = {
  account: CloudInventoryAccountWithRelations;
};

export type CloudIpAllocationWithRelations = z.infer<typeof CloudIpAllocationSchema> & CloudIpAllocationRelations

export const CloudIpAllocationWithRelationsSchema: z.ZodType<CloudIpAllocationWithRelations> = CloudIpAllocationSchema.merge(z.object({
  account: z.lazy(() => CloudInventoryAccountWithRelationsSchema),
}))